import { computed } from "mobx";

class Payment {

  constructor(json = {}) {
    json = json || {}
    this.adrenalyze_amount = json.adrenalyze_amount
    this.adrenalyze_percentage = json.adrenalyze_percentage
    this.adventure_idx = json.adventure_idx
    this.boleto_code = json.boleto_code
    this.boleto_href = json.boleto_href
    this.company_amount = json.company_amount
    this.company_idx = json.company_idx
    this.company_percentage = json.company_percentage
    this.created_at = json.created_at
    this.escrow = json.escrow
    this.fk_discount = json.fk_discount
    this.fk_user = json.fk_user
    this.installment = json.installment
    this.is_deleted = json.is_deleted
    this.method = json.method
    this.payment_id = json.payment_id
    this.payment_status = json.payment_status
    this.people_payed = json.people_payed
    this.pk_payment = json.pk_payment
    this.prevision_date = json.prevision_date
    this.price = json.price
    this.released_date = json.released_date
    this.authorized_date = json.authorized_date
    this.request_idx = json.request_idx
    this.settled_date = json.settled_date
    this.short_url = json.short_url
    this.updated_at = json.updated_at
  }

  @computed
  get paymentMethodLabel() {
    let paymentMethodLabel;

    switch (this.method) {
      case "CREDIT_CARD":
        paymentMethodLabel = 'Cartão de crédito'
        break;
      case "BOLETO":
        paymentMethodLabel = 'Boleto'
        break;
      case "LOCAL":
        paymentMethodLabel = 'Pagar no local'
        break;
      default:
        paymentMethodLabel = '';
        break;
    }

    return paymentMethodLabel
  }

  @computed
  get paymentStatusLabel() {
    switch (this.payment_status) {
      case "REFUNDED":
        return 'Reembolsado' // PENDENTE
      case "WAITING":
        return 'Custódia' // PENDENTE
      case "IN_ANALYSIS":
        return 'Análise' // PENDENTE
      case "CANCELLED":
        return 'Cancelado' // PENDENTE
      case "AUTHORIZED":
        return 'Autorizado' // PAGO
      case "SETTLED":
        return 'Liquidado' // PAGO
      default:
        return '';
    }
  }

  @computed
  get isInAnalysis() {
    return this.payment_status === 'IN_ANALYSIS'
  }

  @computed
  get isWaiting() {
    return this.payment_status === 'WAITING'
  }

}

export default Payment;


// WEBPACK FOOTER //
// ./src/models/Payment.js